module.exports = __webpack_public_path__ + "img/5.55440b79.png";